import React, { FC } from 'react';
import styles from './FirstMonthPromotion.module.scss';
import checkMark from '../../../../assets/img/chekMark.svg';
import { usePrefetchQuery } from '../../../../pages/movies/movieDetails/query';

interface FirstMonthPromotionI {}

const FirstMonthPromotion: FC<FirstMonthPromotionI> = () => {
  const { prefetchData } = usePrefetchQuery();

  const perkItem = (text: string) => {
    return (
      <div className={styles.perkItem}>
        <img src={checkMark} alt="" />
        <h5>{text}</h5>
      </div>
    );
  };

  const perksLeft = [
    'Immer die neuesten Filme & exklusive Produktionen',
    'Leihen, kaufen oder streamen ohne Limit',
    'Monatlich kündbar',
  ];

  const perksRight = ['Jetzt Gratisfilm sichern', 'Diskrete Abrechnung & 100% Jugendschutz'];

  return (
    <div className={styles.container}>
      <h2>SIEH MAL EINER AN!</h2>
      <h3>JETZT IM ERSTEN MONAT FÜR NUR € 0,99*</h3>
      <div className={styles.desktopPerks}>
        <div className={styles.perks}>
          {perksLeft.map((perk) => {
            return perkItem(perk);
          })}
        </div>
        <div className={styles.perks}>
          {perksRight.map((perk) => {
            return perkItem(perk);
          })}
        </div>
      </div>
      <div className={styles.mobilePerks}>
        <div className={styles.perks}>
          {[...perksLeft, ...perksRight].map((perk) => {
            return perkItem(perk);
          })}
        </div>
      </div>
      {prefetchData?.user_country_code !== 'AT' ? (
        <p className={styles.disclaimer}>
          * Gültig bei Abschluss eines Monatstickets für Blue Movie Plus-Inhalte. Für den ersten Monat ist eine
          Abogebühr i.H.v. € 0,99 fällig, ab dem 2. Monat beträgt die Abogebühr monatlich € 22. Das Monatsticket hat
          eine unbefristete Laufzeit und kann erstmals zum Ende des ersten Monats, danach mit einer Frist von 5 Tagen
          gekündigt werden. Angebot buchbar auf der bluemovie.com. Alle Preise inkl. MwSt.
        </p>
      ) : (
        <p className={styles.disclaimer}>
          * Gültig bei Abschluss eines Monatstickets für Blue Movie Plus-Inhalte. Das Monatsticket hat eine unbefristete
          Laufzeit und die Mindestvertragslaufzeit (MVLZ) beträgt 1 Monat. Das Monatsticket kann erstmals zum Ablauf der
          MVLZ, danach jeweils zum Kalendermonatsende gekündigt werden. Die Kündigungsfrist beträgt jeweils 5 Tage. Für
          den ersten Monat ist eine Abogebühr i.H.v. € 0,99 fällig, ab dem 2. Monat beträgt die Abogebühr monatlich €
          22. Die Abbuchung der Abogebühren erfolgt jeweils monatlich im Voraus. Alle Preise inkl. USt.
        </p>
      )}
    </div>
  );
};

export default FirstMonthPromotion;
